import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private readonly oauth: OAuthService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.oauth.getAccessToken();
    const isOidcRequest =
      req.url.includes('/.well-known/openid-configuration') ||
      req.url.includes('/jwks') ||
      req.url.includes('/token') ||
      req.url.includes('/userinfo') ||
      req.url.includes('/revoke');

    if (isOidcRequest || !token || req.headers.has('Authorization')) {
      return next.handle(req);
    }

    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
    return next.handle(authReq);
  }
}
